var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",class:[{'accordion-flush': _vm.flush}],attrs:{"id":_vm.id}},_vm._l((_vm.list),function(item,index){return _c('b-accordion-item',{key:index,attrs:{"item":item,"parent":_vm.id,"index":index,"allways-open":_vm.allwaysOpen},scopedSlots:_vm._u([{key:"header",fn:function(ref){
var item = ref.item;
return [_vm._t("header",null,{"item":item})]}},{key:"body",fn:function(ref){
var item = ref.item;
return [_vm._t("body",null,{"item":item})]}}],null,true)})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }